import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { hexOpacity } from '#/common/utils/hexOpacity';
import {
  CardWrapper,
  IconWrapper,
  ContentWrapper,
  Title,
  Subtitle,
  CheckmarkWrapper,
} from './Styles';
import FAIcon from '#/common/components/FAIcon';

export interface SelectCardProps {
  id: string;
  iconName?: string;
  title: string;
  subtitle?: string;
  selected?: boolean;
  onClick?: (id: string) => void;
  iconColor?: string;
  iconHolderOpacity?: number;
}

const SelectCard: React.FC<SelectCardProps> = ({
  id,
  iconName,
  title,
  subtitle,
  selected = false,
  onClick,
  iconColor,
  iconHolderOpacity = 0.6,
}) => {
  const handleClick = () => {
    onClick?.(id);
  };

  const iconHolderColor = iconColor ? hexOpacity(iconColor, iconHolderOpacity) : undefined;

  return (
    <CardWrapper
      className="select-card"
      selected={selected}
      hasIcon={!!iconName}
      onClick={handleClick}>
      {iconName && (
        <IconWrapper selected={selected} iconColor={iconColor} iconHolderColor={iconHolderColor}>
          <FAIcon icon={iconName} size="xl" />
        </IconWrapper>
      )}

      <ContentWrapper>
        <Title selected={selected} type="body">
          {title}
        </Title>
        {subtitle && (
          <Subtitle selected={selected} type="body">
            {subtitle}
          </Subtitle>
        )}
      </ContentWrapper>

      <CheckmarkWrapper className="checkmark-wrapper" selected={selected}>
        <FAIcon icon="circle-check" />
      </CheckmarkWrapper>
    </CardWrapper>
  );
};

export default React.memo(SelectCard);
